const USER_STATUS = {
  A: "A",
  B: "B",
  I: "I"
}

export default USER_STATUS